module.exports = __webpack_public_path__ + "img/Zuilen_pin_reunie.55b31fa9.svg";